import { useEffect } from 'react';

export const AfterPageReady = () => {
  useEffect(() => {
    // do not remove: this is to dismiss the fallback timer that reloads the page with backup resource server
    window.isPageReady = true;
  }, []);
  return null;
};
